import { Fragment, type CSSProperties } from 'react';

const titleLines = ['Sala, cocina y caja.', 'Todo conectado.'];
export const HERO_TITLE_LETTER_COUNT = titleLines.join('').replace(/\s/g, '').length;

/** Keep words intact when wrapping and expose one complete heading to assistive tech. */
export function HeroTitle() {
  let letterIndex = 0;

  return (
    <h1 id="home-title" aria-label={titleLines.join(' ')}>
      <span aria-hidden="true">
        {titleLines.map((line, lineIndex) => (
          <Fragment key={line}>
            {lineIndex > 0 && <br />}
            <span className={lineIndex > 0 ? 'hero-title__accent' : undefined}>
              {line.split(' ').map((word, wordIndex) => (
                <Fragment key={`${wordIndex}-${word}`}>
                  {wordIndex > 0 && ' '}
                  <span className="hero-title__word">
                    {Array.from(word).map((letter, index) => (
                      <span
                        key={index}
                        className="hero-title__letter"
                        style={{ '--hero-letter-index': letterIndex++ } as CSSProperties}
                      >
                        {letter}
                      </span>
                    ))}
                  </span>
                </Fragment>
              ))}
            </span>
          </Fragment>
        ))}
      </span>
    </h1>
  );
}
